import { useSelector } from "react-redux";
import { Table, Badge } from "react-bootstrap";
import { useState, useEffect } from "react";

const dateToString = (d) => {
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const seconds = d.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

function Orders(props) {
  let orderData = useSelector((state) => state.orderArray[0]);
  const orders = props.data.map((obj) => obj.order);
  
  const uniqueOrders = orders.reduce((accumulator, current) => {
    const index = accumulator.findIndex((item) => item.id === current.id);
    if (index < 0) {
      accumulator.push(current);
    } else {
      accumulator[index] = current;
    }
    return accumulator;
  }, []);
  
  const newOrders = uniqueOrders.filter((obj) =>
    // Case 1: "new" or "partially_filled" (these are active regardless of filled_at)
    (obj.status === "new" ) 
    || (obj.status === "partially_filled")
    // Case 2: "replaced" AND obj.filled_qty is 0 (not yet fully filled)
    ||(obj.status === "replaced" && obj.filled_qty === 0)
    || (obj.status === "held" && obj.filled_qty === 0)
  );
  console.log("New orders:", newOrders)
  if (newOrders.length === 0) {
    return null;
  }

  let orderDisplayValue = newOrders.map((info) => {
    return (
      <tr key={info.id}>
        <td style={{ color: '#888' }}>{dateToString(new Date(info.submitted_at))}</td>
        <td>
          <span style={{ 
            color: info.side === 'buy' ? '#00ff88' : '#ff4444',
            fontWeight: '600'
          }}>
            {info.side.toUpperCase()}
          </span>
        </td>
        <td style={{ color: '#aaa' }}>{info.type?.toUpperCase() ?? ''}</td>
        <td>
          <Badge 
            bg={info.status === 'new' ? 'info' : 'warning'}
            style={{
              backgroundColor: info.status === 'new' ? '#00d4ff' : '#ffa500',
              color: '#000',
              fontSize: '0.75rem',
              padding: '4px 8px'
            }}
          >
            {info.status === 'partially_filled' ? 'PARTIAL' : 'PENDING'}
          </Badge>
        </td>
        <td style={{ color: '#fff', fontWeight: '500' }}>
          {info.filled_qty == 0 ? info.qty : `${info.filled_qty}/${info.qty}`}
        </td>
        <td style={{ color: '#00d4ff', fontWeight: '500' }}>
          ${parseFloat(info.limit_price || 0).toFixed(2)}
        </td>
      </tr>
    );
  });

  return (
    <div style={{
      backgroundColor: '#0a0a0a',
      border: '1px solid #222',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '20px'
    }}>
      <h5 style={{ 
        color: '#00d4ff', 
        marginBottom: '16px',
        fontSize: '1rem',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Open Orders ({newOrders.length})
      </h5>
      
      <div style={{ 
        maxHeight: "250px",
        overflowY: "auto",
        overflowX: "hidden"
      }}>
        <Table 
          hover
          style={{
            fontSize: "0.85rem",
            marginBottom: 0,
            color: '#ccc'
          }}
          className="orders-table"
        >
          <thead style={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#0a0a0a',
            zIndex: 1
          }}>
            <tr>
              <th style={{ 
                borderBottom: '2px solid #222',
                color: '#888',
                fontWeight: '600',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                paddingBottom: '8px'
              }}>Time</th>
              <th style={{ 
                borderBottom: '2px solid #222',
                color: '#888',
                fontWeight: '600',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                paddingBottom: '8px'
              }}>Side</th>
              <th style={{ 
                borderBottom: '2px solid #222',
                color: '#888',
                fontWeight: '600',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                paddingBottom: '8px'
              }}>Type</th>
              <th style={{ 
                borderBottom: '2px solid #222',
                color: '#888',
                fontWeight: '600',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                paddingBottom: '8px'
              }}>Status</th>
              <th style={{ 
                borderBottom: '2px solid #222',
                color: '#888',
                fontWeight: '600',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                paddingBottom: '8px'
              }}>Qty</th>
              <th style={{ 
                borderBottom: '2px solid #222',
                color: '#888',
                fontWeight: '600',
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                paddingBottom: '8px'
              }}>Price</th>
            </tr>
          </thead>
          <tbody>{orderDisplayValue}</tbody>
        </Table>
      </div>

      <style jsx>{`
        .orders-table tbody tr {
          border-bottom: 1px solid #1a1a1a;
        }
        .orders-table tbody tr:hover {
          background-color: #111 !important;
        }
        .orders-table td {
          padding: 10px 8px;
          border: none;
        }
        .orders-table th {
          padding: 8px;
          border: none;
        }
      `}</style>
    </div>
  );
}

export default Orders;